export const appBarMeta = {
	"product-home": {
		title: "Study-Pack",
		description: "Extra practice to help you feel ready for your exam.",
	},
	podcasts: {
		title: "navbar.podcasts",
		description: "appbar.podcasts.description",
	},
	"practice-tests": {
		title: (label?: string) => label ?? "Practice Tests",
		description: (label?: string) =>
			`Take ${label?.toLocaleLowerCase() ?? "practice tests"} to assess your exam readiness, strengths, and opportunities for improvement`,
	},
	store: {
		title: "Test-Prep Store",
		description: "Maximize your exam readiness with premium study materials",
	},
	leaderboard: {
		title: "navbar.leaderboard",
		description: "appbar.leaderboard.description",
	},
	profile: {
		title: "Profile",
		description: "View your profile",
	},
	progress: {
		title: "Progress",
		description: "See your performance and where to improve.",
	},
};
